import { Component, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { DsBreakpoints } from '@levelaccess/design-system';

import { WindowService } from '../../services/window.service';
import { UserService } from '../../services/user.service';
import { NavService } from '../../services/navigation/nav.service';

@Component({
  selector: 'compound-navbar',
  templateUrl: './compound-navbar.component.html',
  styleUrls: ['./compound-navbar.component.scss'],
  standalone: false,
})
export class CompoundNavbarComponent implements OnInit {
  public showMobileNavVersion$: Observable<boolean>;
  public isAuthenticated$: Observable<boolean>;
  protected isVerticalNavigationEnabled: Signal<boolean>;
  protected isSmallViewport: Signal<boolean>;

  constructor(
    private windowService: WindowService,
    private userService: UserService,
    private navService: NavService,
  ) {
    this.isVerticalNavigationEnabled = toSignal(this.navService.isVerticalNavigationEnabled$);
    this.isSmallViewport = toSignal(this.windowService.observeBreakpoint(DsBreakpoints.Small), { initialValue: false });
  }

  public ngOnInit(): void {
    const mobileBreakpoint = this.isVerticalNavigationEnabled() ? DsBreakpoints.Medium : DsBreakpoints.Large;
    this.showMobileNavVersion$ = this.windowService.observeBreakpoint(mobileBreakpoint);
    this.isAuthenticated$ = this.userService.isAuthenticated$;
  }
}
